(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("icepath"), require("startlibs/lib/lib"), require("startlibs/lib/hocs"), require("polished"), require("startlibs"), require("react-redux"), require("redux"), require("react-dom"), require("recompose"), require("react-router-dom"), require("react-slot-fill"), require("mitt"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define("statlibs", ["react", "styled-components", "icepath", "startlibs/lib/lib", "startlibs/lib/hocs", "polished", "startlibs", "react-redux", "redux", "react-dom", "recompose", "react-router-dom", "react-slot-fill", "mitt", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["statlibs"] = factory(require("react"), require("styled-components"), require("icepath"), require("startlibs/lib/lib"), require("startlibs/lib/hocs"), require("polished"), require("startlibs"), require("react-redux"), require("redux"), require("react-dom"), require("recompose"), require("react-router-dom"), require("react-slot-fill"), require("mitt"), require("prop-types"));
	else
		root["statlibs"] = factory(root["react"], root["styled-components"], root["icepath"], root["startlibs/lib/lib"], root["startlibs/lib/hocs"], root["polished"], root["startlibs"], root["react-redux"], root["redux"], root["react-dom"], root["recompose"], root["react-router-dom"], root["react-slot-fill"], root["mitt"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_25__, __WEBPACK_EXTERNAL_MODULE_42__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AJAX_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setAjaxDefaultError; });
/* harmony export (immutable) */ __webpack_exports__["f"] = makeActionCreator;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reducerCreator; });
/* unused harmony export arrToMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SET_ERRORS = 'SET_ERRORS';
var CLEAR_ERRORS = 'CLEAR_ERRORS';
var REMOVE_LOADING = 'REMOVE_LOADING';
var ADD_LOADING = 'ADD_LOADING';
var AJAX_ERROR = '';
var setAjaxDefaultError = function setAjaxDefaultError(s) {
  return AJAX_ERROR = s;
};

function makeActionCreator(key, reducer, fetcher) {
  var fn = function fn(possiblePayload, possibleActionMeta) {
    return function (dispatch, getState) {
      var payload = (typeof possiblePayload === 'undefined' ? 'undefined' : _typeof(possiblePayload)) !== 'object' || Array.isArray(possiblePayload) || possiblePayload.constructor === Object ? possiblePayload : {};
      var actionMeta = (typeof possibleActionMeta === 'undefined' ? 'undefined' : _typeof(possibleActionMeta)) === 'object' && possibleActionMeta.constructor === Object ? possibleActionMeta : {};
      var meta = _extends({
        _origin: key,
        _payload: payload
      }, actionMeta, {
        actionId: (actionMeta ? actionMeta.actionId : '') || ''
      });
      if (fetcher && !meta._dontFetch) {
        dispatch({ type: CLEAR_ERRORS, payload: meta.actionKey || key + meta.actionId, meta: meta });
        dispatch({ type: ADD_LOADING, meta: meta });
        var fetched = fetcher(payload, actionMeta).then(function (response) {
          if (response.errors) {
            throw response;
          } else {
            dispatch({
              type: key,
              payload: response.success || response,
              meta: _extends({}, meta, response)
            });
          }
          return { success: response.success || response, meta: meta };
        }).catch(function (e) {
          if (e.errors) {
            dispatch({ type: SET_ERRORS, payload: e.errors, meta: meta });
            return { errors: e.errors, meta: meta };
          } else if (e.errorResponse) {
            return { errors: true, response: e.errorResponse, meta: meta };
          } else {
            console.log(e);
            dispatch({ type: SET_ERRORS, payload: { _connection_error_: [AJAX_ERROR] }, meta: _extends({}, meta, { _errorType: e.name }) });
            return { errors: e, meta: meta };
          }
        });
        fetched.then(function (v) {
          return dispatch({ type: REMOVE_LOADING, payload: v, meta: meta });
        });
        return fetched;
      } else {
        dispatch({ type: key, payload: payload, meta: meta });
        return Promise.resolve({ success: payload, meta: meta });
      }
    };
  };
  var actionCreator = fn;
  actionCreator.toString = function () {
    return key;
  };
  actionCreator.reducer = reducer;
  return actionCreator;
}

var reducerCreator = function reducerCreator(initialState, actions) {
  var reducer = actions.reduce(function (acc, action) {
    return _extends({}, acc, _defineProperty({}, action, action.reducer));
  }, {});
  return function (extraReducers) {
    var finalReducer = _extends({}, reducer, extraReducers);
    return function (state, action) {
      return finalReducer[action.type] ? finalReducer[action.type](__WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].chain(state), action.payload, action.meta).value() : state || initialState;
    };
  };
};

function arrToMap(arr) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

  var map = {};
  for (var i = 0; i < arr.length; i++) {
    map[arr[i][key]] = arr[i];
  }
  return map;
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMargin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ifProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return media; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_polished__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styled_components__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    @media screen and (max-width: 600px) {\n      ', '\n    }\n  '], ['\n    @media screen and (max-width: 600px) {\n      ', '\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    @media screen and (min-width: 601px) {\n      ', '\n    }\n  '], ['\n    @media screen and (min-width: 601px) {\n      ', '\n    }\n  ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var getColor = function getColor(propsOrColor, hover) {
  if (typeof propsOrColor === 'string') {
    return function (_ref) {
      var theme = _ref.theme;
      return theme.colors[propsOrColor];
    };
  }

  var theme = propsOrColor.theme,
      props = _objectWithoutProperties(propsOrColor, ['theme']);

  if (props.dark) {
    return __WEBPACK_IMPORTED_MODULE_1_polished__["darken"](0.1, getColor(_extends({ theme: theme }, __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].unset(props, 'dark'))));
  } else if (hover && props.hover) {
    return getColor({ theme: theme, color: props.hover });
  } else if (props.color) {
    return theme.colors[props.color] || props.color;
  } else if (props.highlight) {
    return theme.colors.main;
  } else if (props.alert) {
    return theme.colors.alert;
  } else if (props.success) {
    return theme.colors.success;
  } else {
    return theme.colors.gray150;
  }
};


var getMargin = function getMargin(enumeratedMargins) {
  return function (props) {
    return enumeratedMargins[props.margin] || props.margin || enumeratedMargins['default'] || 0;
  };
};

/**
 * Returns the value of `props[path]` or `defaultValue`
 * @example
 * const Button = styled.button`
 *  color: ${prop('color', 'red')};
 * `
 */
var getProp = function getProp(path, defaultValue) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, [].concat(path)) || defaultValue;
  };
};

var customTheme = function customTheme(type) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, ["theme", "startlibs", type]) || '';
  };
};

/**
 * Returns `pass` if prop is truthy. Otherwise returns `fail`
 * @example
 * // usage with styled-theme
 * import styled from 'styled-components'
 * import { ifProp } from 'styled-tools'
 * import { palette } from 'styled-theme'
 *
 * const Button = styled.button`
 *  background-color: ${ifProp('transparent', 'transparent', palette(0))};
 *  color: ${ifProp(['transparent', 'accent'], palette('secondary', 0))};
 *  font-size: ${ifProp({ size: 'large' }, '20px', ifProp({ size: 'medium' }, '16px', '12px'))};
 *`
 */
var ifProp = function ifProp(path, pass, fail) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var result = false;
    if (Array.isArray(path)) {
      result = path.every(function (p) {
        return testSinglePath(props, p);
      });
    } else if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object') {
      result = !Object.entries(path).find(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];

        return props[k] !== v;
      });
    } else {
      result = testSinglePath(props, path);
    }
    return result ? pass : fail;
  };
};

var media = {
  mobile: function mobile() {
    return __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"](_templateObject, __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"].apply(undefined, arguments));
  },
  desktop: function desktop() {
    return __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"](_templateObject2, __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"].apply(undefined, arguments));
  }
};

function testSinglePath(props, path) {
  if (typeof path === 'string') {
    return !!__WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, path);
  } else if (typeof path === 'number') {
    return !!props[path];
  } else {
    return false;
  }
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class;

var _templateObject = _taggedTemplateLiteral(['\n  font-family: \'', '\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  \n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  user-select: none; \n  ', '\n'], ['\n  font-family: \'', '\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  \n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  user-select: none; \n  ', '\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var IconComponent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["withTheme"](_class = function (_React$Component) {
  _inherits(IconComponent, _React$Component);

  function IconComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IconComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconComponent.__proto__ || Object.getPrototypeOf(IconComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var icon = this.props.icon;
      if ((this.props.theme.svgIcons || {})[icon]) {
        this.props.theme.svgLoader(icon).then(function (i) {
          return _this2.setState({ Svg: i.default });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          children = _props.children,
          withImageHeader = _props.withImageHeader,
          theme = _props.theme,
          clickable = _props.clickable,
          customIcon = _props.customIcon,
          colorSet = _props.colorSet,
          color = _props.color,
          rest = _objectWithoutProperties(_props, ['icon', 'children', 'withImageHeader', 'theme', 'clickable', 'customIcon', 'colorSet', 'color']);

      if ((theme.svgIcons || {})[icon]) {
        if (this.state.Svg) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.state.Svg, rest);
        } else {
          return null;
        }
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        rest,
        theme.icons[icon] || customIcon && icon,
        children
      );
    }
  }]);

  return IconComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class;

var Icon = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(IconComponent)(_templateObject, function (props) {
  return props.theme.iconFont;
}, function (props) {
  return props.clickable && '\n    cursor: pointer;\n    &:hover {\n      opacity: 0.85;\n    }\n  ';
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fieldMargins; });
/* unused harmony export FieldDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Field; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _templateObject = _taggedTemplateLiteral(['\n  color: #c3282d;\n  margin-left: 1px;\n  vertical-align: top;\n  line-height: 100%;\n  margin-top: -1px;\n  ', '\n'], ['\n  color: #c3282d;\n  margin-left: 1px;\n  vertical-align: top;\n  line-height: 100%;\n  margin-top: -1px;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  margin-bottom: ', ';\n'], ['\n  position: relative;\n  margin-bottom: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-weight: 500;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: .5rem;\n  ', '\n  ', '\n'], ['\n  font-weight: 500;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: .5rem;\n  ', '\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 13px;\n  font-weight: 400;\n'], ['\n  color: ', ';\n  font-size: 13px;\n  font-weight: 400;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: rgba(0,0,0,0.4);\n  display: block;\n  font-size: 12px;\n  margin: 0.25rem 0;\n  font-weight: 400;\n'], ['\n  color: rgba(0,0,0,0.4);\n  display: block;\n  font-size: 12px;\n  margin: 0.25rem 0;\n  font-weight: 400;\n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var fieldMargins = { none: '0', big: '2rem', 'default': '1rem' };

var Mandatory = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.span(_templateObject, function (props) {
  return typeof props.mandatory === 'string' && 'color: ' + props.mandatory + ';';
});
var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.div(_templateObject2, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](fieldMargins));
var Label = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.label(_templateObject3, function (props) {
  return props.onImage && 'color: #fff;';
}, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["customTheme"]("FieldLabel"));

var HelpText = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.span(_templateObject4, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"]('gray120'));
var FieldDescription = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.span(_templateObject5);

var Field = (_temp = _class = function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
  }

  _createClass(Field, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          children = _props.children,
          focused = _props.focused,
          mandatory = _props.mandatory,
          descText = _props.descText,
          helpText = _props.helpText,
          labelClick = _props.labelClick,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['label', 'children', 'focused', 'mandatory', 'descText', 'helpText', 'labelClick', 'className']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Container,
        _extends({}, rest, { className: className }),
        label && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Label,
          _extends({}, rest, { onClick: labelClick }),
          label,
          mandatory && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Mandatory,
            { mandatory: mandatory },
            '*'
          ),
          helpText && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            HelpText,
            null,
            ' ',
            helpText
          ),
          descText && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            FieldDescription,
            null,
            descText
          )
        ),
        children
      );
    }
  }]);

  return Field;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.Label = Label, _class.Container = Container, _class.HelpText = HelpText, _class.Description = FieldDescription, _class.displayName = "Field", _temp);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return postFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFetcher; });
/* unused harmony export innerFetcher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closePopups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return openPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lazyLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return removeLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return uiReducer; });
/* harmony export (immutable) */ __webpack_exports__["b"] = arrToMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionHelpers__ = __webpack_require__(6);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var postFetcher = function postFetcher(url, json, extraParams) {
  return innerFetcher(url, json, _extends({
    method: 'POST',
    headers: typeof json === "string" || json.constructor === FormData ? {} : { 'Content-Type': 'application/json; charset=UTF-8' },
    body: typeof json === "string" ? json : json.constructor === FormData ? json : JSON.stringify(json)
  }, extraParams));
};

var addQueryString = function addQueryString(url, obj) {
  return !obj || !Object.keys(obj).length ? url : url + '?' + Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return v !== undefined && v !== null;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
};

var getFetcher = function getFetcher(url, jsonParams, extraParams) {
  return innerFetcher(addQueryString(url, jsonParams), undefined, _extends({
    method: 'GET'
  }, extraParams));
};

var innerFetcher = function innerFetcher(url, json, extraParams) {
  return fetch(url, _extends({
    credentials: 'same-origin'
  }, extraParams)).then(function (e) {
    return e.status >= 400 ? Promise.reject(e.json()) : e.text();
  }).catch(function (e) {
    return e.then ? e.then(function (e) {
      return Promise.reject(e.errors ? e : { errorResponse: e });
    }) : Promise.reject(e);
  }).then(function (e) {
    if (e && typeof e === 'string') {
      try {
        return JSON.parse(e);
      } catch (e) {
        return e;
      }
    } else {
      return e;
    }
  });
};

var formFetch = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('FORM_FETCH', function (s) {
  return s;
}, function (obj, _ref5) {
  var url = _ref5.url;
  return postFetcher(url, obj);
});

var closePopups = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('CLOSE_POPUPS', function () {
  return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"](false);
});
var openPopup = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('OPEN_POPUP', function (chain, id, _ref6) {
  var value = _ref6.value;
  return chain.set(_defineProperty({}, id, value));
});
var popupsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */](false, [closePopups, openPopup]);

var getActionKey = function getActionKey(meta) {
  return meta.actionKey || meta._origin + meta.actionId;
};
var setErrors = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["e" /* SET_ERRORS */], function (chain, errors, meta) {
  return chain.set(getActionKey(meta), errors);
});
var clearErrors = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["c" /* CLEAR_ERRORS */], function (chain, key, _ref7) {
  var path = _ref7.path;
  return chain.update([key], function (errorMap) {
    return !path ? false : __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].filter(errorMap || {}, function (v, k) {
      return k.indexOf(path.join('.')) < 0;
    });
  });
});

var removeError = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('REMOVE_ERROR', function (chain, key, _ref8) {
  var errorKey = _ref8.key,
      value = _ref8.value;
  return chain.on(key, function (errorsChain) {
    return errorsChain.filter(errorKey, function (v) {
      return v !== value || !value;
    }).map(function (errorList) {
      return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].filter(errorList, function (e) {
        return e !== '$' + errorKey;
      });
    }).filter(function (errorList) {
      return errorList.length;
    });
  });
});
var errorsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */]({}, [setErrors, removeError, clearErrors]);

var lazyLoadAction = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('LAZY_LOAD', function (chain) {
  return chain;
}, function (url) {
  return postFetcher(url, {});
});
var lazyLoad = function lazyLoad(payload, meta) {
  return lazyLoadAction(payload, _extends({ _dontNotify: true }, meta));
};
lazyLoad.toString = lazyLoadAction.toString;

var addLoading = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["a" /* ADD_LOADING */], function (chain, _, meta) {
  return chain.set(getActionKey(meta), true);
});
var removeLoading = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["d" /* REMOVE_LOADING */], function (chain, _, meta) {
  return chain.unset(getActionKey(meta));
});
var loadingsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */]({}, [addLoading, removeLoading]);

var hasFetchedReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */](0, []);

var uiReducer = function uiReducer(extraReducers) {
  return __WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"](_extends({
    openPopup: popupsReducer(),
    errors: errorsReducer(),
    loadings: loadingsReducer(),
    hasFetched: hasFetchedReducer(_defineProperty({}, lazyLoad, function () {
      return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"](Date.now());
    }))
  }, extraReducers));
};

function arrToMap(arr) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "id";

  var map = {};
  for (var i = 0; i < arr.length; i++) {
    map[arr[i][key]] = arr[i];
  }
  map.order = arr.map(function (_) {
    return _[key];
  });
  return map;
}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Link = __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withRouteTo"](_class = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          replace = _this$props.replace,
          to = _this$props.to,
          skipTo = _this$props.skipTo,
          onClick = _this$props.onClick;

      onClick && onClick(e);
      if (skipTo) {
        return;
      }
      if (e.defaultPrevented) return;
      e.preventDefault();
      _this.props.routeTo(to, replace);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          routeTo = _props.routeTo,
          skipTo = _props.skipTo,
          props = _objectWithoutProperties(_props, ['routeTo', 'skipTo']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"], _extends({ to: skipTo }, props, { onClick: this.handleClick }));
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DropdownIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_polished__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loading__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_styled__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 51%;\n  transform: translateY(-50%);\n  right: 1rem;\n'], ['\n  position: absolute;\n  top: 51%;\n  transform: translateY(-50%);\n  right: 1rem;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position:absolute;\n  bottom: 10px;\n  right: .75rem;\n  left: auto;\n  top: auto;\n  font-size: 18px;\n'], ['\n  position:absolute;\n  bottom: 10px;\n  right: .75rem;\n  left: auto;\n  top: auto;\n  font-size: 18px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  vertical-align: top;\n  border: 0;\n  font-size: 12px;\n  border-radius: 5px;\n  background: ', ';\n  color: white;\n  min-width: 8rem;\n  display: inline-block;\n  line-height: 16px;\n  text-align: center;\n  padding: 10px 1.25rem;\n  outline: none;\n  cursor: pointer;\n  position: relative;\n  text-decoration: none;\n  user-select: none;\n  :hover {\n    background: ', ';\n  }\n  :active {\n    background: ', ';\n  }\n  :focus:after {\n    content: \'\';\n    pointer-events: none;\n    position: absolute;\n    top: -3px;\n    right: -3px;\n    left: -3px;\n    bottom: -3px;\n    border-radius: 7px;\n    border: 2px solid rgba(0, 0, 0, 0.2);\n  }\n  ~ .styled-button {\n    margin-left: 1rem;\n  }\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  vertical-align: top;\n  border: 0;\n  font-size: 12px;\n  border-radius: 5px;\n  background: ', ';\n  color: white;\n  min-width: 8rem;\n  display: inline-block;\n  line-height: 16px;\n  text-align: center;\n  padding: 10px 1.25rem;\n  outline: none;\n  cursor: pointer;\n  position: relative;\n  text-decoration: none;\n  user-select: none;\n  :hover {\n    background: ', ';\n  }\n  :active {\n    background: ', ';\n  }\n  :focus:after {\n    content: \'\';\n    pointer-events: none;\n    position: absolute;\n    top: -3px;\n    right: -3px;\n    left: -3px;\n    bottom: -3px;\n    border-radius: 7px;\n    border: 2px solid rgba(0, 0, 0, 0.2);\n  }\n  ~ .styled-button {\n    margin-left: 1rem;\n  }\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 3rem;\n    min-height: 3rem;\n    ', ' {\n      font-size: 23px;\n      margin-right: 8px;\n      margin-left: -4px;\n      pointer-events: none;\n      line-height: 0;\n    }\n  '], ['\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 3rem;\n    min-height: 3rem;\n    ', ' {\n      font-size: 23px;\n      margin-right: 8px;\n      margin-left: -4px;\n      pointer-events: none;\n      line-height: 0;\n    }\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    padding: 0;\n    ', ' {\n      margin: 0;\n    }\n  '], ['\n    padding: 0;\n    ', ' {\n      margin: 0;\n    }\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    font-size: 12px;\n    padding: 4px 1rem;\n    min-width: 2rem;\n    min-height: 2rem;\n    ', '\n    ', '\n  '], ['\n    font-size: 12px;\n    padding: 4px 1rem;\n    min-width: 2rem;\n    min-height: 2rem;\n    ', '\n    ', '\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      ', ' {\n        font-size: 18px;\n        margin-right: 5px;\n        margin-left: -5px;\n      }\n    '], ['\n      ', ' {\n        font-size: 18px;\n        margin-right: 5px;\n        margin-left: -5px;\n      }\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      padding: 0;\n      ', ' {\n        margin: 0;\n      }\n    '], ['\n      padding: 0;\n      ', ' {\n        margin: 0;\n      }\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    padding-right: 2.25rem;\n    text-align: left;\n  '], ['\n    padding-right: 2.25rem;\n    text-align: left;\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    background: rgba(0,0,0,0.45);\n    :hover {\n      background: rgba(0,0,0,0.50);\n    }\n    :active {\n      background: rgba(0,0,0,0.55);\n    }\n  '], ['\n    background: rgba(0,0,0,0.45);\n    :hover {\n      background: rgba(0,0,0,0.50);\n    }\n    :active {\n      background: rgba(0,0,0,0.55);\n    }\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n    color: ', ';\n    background: #FFFFFF;\n    :hover {\n      background: ', ';\n    }\n    :active {\n      background: ', ';\n    }\n  '], ['\n    color: ', ';\n    background: #FFFFFF;\n    :hover {\n      background: ', ';\n    }\n    :active {\n      background: ', ';\n    }\n  ']),
    _templateObject12 = _taggedTemplateLiteral(['\n    color: transparent !important;\n    pointer-events: none;\n    ', ' {\n      visibility: hidden;\n    }\n  '], ['\n    color: transparent !important;\n    pointer-events: none;\n    ', ' {\n      visibility: hidden;\n    }\n  ']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }









var DropdownIcon = __WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */].extend(_templateObject);
var LockIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */])(_templateObject2);

var Button = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(function (_ref) {
  var type = _ref.type,
      locked = _ref.locked,
      color = _ref.color,
      alpha = _ref.alpha,
      success = _ref.success,
      alert = _ref.alert,
      highlight = _ref.highlight,
      hover = _ref.hover,
      white = _ref.white,
      icon = _ref.icon,
      onlyIcon = _ref.onlyIcon,
      small = _ref.small,
      withDropdown = _ref.withDropdown,
      outline = _ref.outline,
      dashed = _ref.dashed,
      isLoading = _ref.isLoading,
      dark = _ref.dark,
      _ref$TAG = _ref.TAG,
      TAG = _ref$TAG === undefined ? 'button' : _ref$TAG,
      className = _ref.className,
      children = _ref.children,
      colorSet = _ref.colorSet,
      concealed = _ref.concealed,
      buttonRef = _ref.buttonRef,
      props = _objectWithoutProperties(_ref, ['type', 'locked', 'color', 'alpha', 'success', 'alert', 'highlight', 'hover', 'white', 'icon', 'onlyIcon', 'small', 'withDropdown', 'outline', 'dashed', 'isLoading', 'dark', 'TAG', 'className', 'children', 'colorSet', 'concealed', 'buttonRef']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    TAG,
    _extends({}, props, { ref: buttonRef, className: className + ' styled-button', type: TAG === 'button' ? type : '' }),
    icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */], { icon: icon }),
    withDropdown && !locked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownIcon, { icon: 'arrow-down' }),
    locked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LockIcon, { icon: 'lock' }),
    children,
    isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Loading__["a" /* Loading */], { white: true, absolute: true })
  );
}).attrs({ type: 'button' })(_templateObject3, __WEBPACK_IMPORTED_MODULE_6__lib_styled__["b" /* getColor */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_3_polished__["darken"](0.05, __WEBPACK_IMPORTED_MODULE_6__lib_styled__["b" /* getColor */](props, true));
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_3_polished__["darken"](0.08, __WEBPACK_IMPORTED_MODULE_6__lib_styled__["b" /* getColor */](props, true));
}, function (props) {
  return props.icon && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject4, __WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */]);
}, function (props) {
  return props.onlyIcon && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject5, __WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */]);
}, function (props) {
  return props.small && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject6, props.icon && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject7, __WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */]), props.onlyIcon && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject8, __WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */]));
}, function (props) {
  return props.withDropdown && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject9);
}, function (props) {
  return (props.outline || props.dashed) && '\n    color: ' + (props.white ? 'white' : 'rgba(0,0,0,0.6)') + ';\n    background: none;\n    ' + __WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */] + ', ' + DropdownIcon + ' {\n      color: ' + (props.white ? 'white' : 'rgba(0,0,0,0.5)') + ';\n    }\n    :before {\n      content: \'\';\n      border: 1px ' + (props.outline ? 'solid' : 'dashed') + ' ' + (props.white ? 'white' : 'rgba(0,0,0,0.35)') + ';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      border-radius: 5px;\n      pointer-events: none;\n    }\n    :hover {\n        background-color: rgba(0,0,0,0.05);\n    }\n    :active {\n        background-color: rgba(0,0,0,0.08);\n    }\n    :focus {\n      :before {\n        box-shadow: 0 0 0 2px rgba(0,0,0,0.1);\n      }\n      :after {\n        content: none;\n      }\n    }\n  ';
}, function (props) {
  return props.alpha && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject10);
}, function (props) {
  return props.white && !props.outline && !props.dashed && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject11, __WEBPACK_IMPORTED_MODULE_6__lib_styled__["b" /* getColor */]('main'), __WEBPACK_IMPORTED_MODULE_3_polished__["darken"](0.05, '#FFFFFF'), __WEBPACK_IMPORTED_MODULE_3_polished__["darken"](0.08, '#FFFFFF'));
}, function (props) {
  return props.isLoading && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject12, __WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */]);
}, __WEBPACK_IMPORTED_MODULE_6__lib_styled__["a" /* customTheme */]("Button"));


Button.a = function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, props, { className: props.className, TAG: 'a' }));
};
Button.Link = function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, props, { className: props.className, TAG: __WEBPACK_IMPORTED_MODULE_2__Link__["a" /* Link */] }));
};
/* unused harmony default export */ var _unused_webpack_default_export = (Button);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styled_components__);
var _templateObject = _taggedTemplateLiteral(['\n    z-index:1;\n    ', '\n    border-style: solid;\n    border-radius: 50%;\n    width: ', 'px;\n    height: ', 'px;\n    border-width: ', 'px;\n    animation: spin 1s linear infinite;\n    ', '\n  '], ['\n    z-index:1;\n    ', '\n    border-style: solid;\n    border-radius: 50%;\n    width: ', 'px;\n    height: ', 'px;\n    border-width: ', 'px;\n    animation: spin 1s linear infinite;\n    ', '\n  ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }



var Loading = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.div(_templateObject, function (props) {
  return props.white ? '\n      border-color: rgba(255,255,255,0.4);\n      border-top-color: ' + (props.color || 'rgba(255,255,255,0.9)') + ';\n    ' : '\n      border-color: rgba(0,0,0,0.1);\n      border-top-color: ' + (props.color || props.theme.colors.main) + ';\n    ';
}, function (props) {
  return props.size || 26;
}, function (props) {
  return props.size || 26;
}, function (props) {
  return props.borderWidth || 4;
}, function (props) {
  return props.absolute && '\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      left: 0;\n      margin: auto;\n      transform: translate(-50%,-50%);\n    ';
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SplitColumnsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fixDoubledLastMarginBottom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_Field__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n\n  margin-bottom: ', 'rem;\n\n  @media (min-width:', 'px) {\n    display: flex;\n    flex-wrap: nowrap;\n    margin-left: -', 'rem;\n    margin-right: -', 'rem;\n    margin-top: -', 'rem;\n    > * {\n      flex-basis: 0;\n      flex-grow: 1;\n      margin-left: ', 'rem;\n      margin-right: ', 'rem;\n      margin-top: ', 'rem;\n    }\n  }\n\n  ', '\n'], ['\n\n  margin-bottom: ', 'rem;\n\n  @media (min-width:', 'px) {\n    display: flex;\n    flex-wrap: nowrap;\n    margin-left: -', 'rem;\n    margin-right: -', 'rem;\n    margin-top: -', 'rem;\n    > * {\n      flex-basis: 0;\n      flex-grow: 1;\n      margin-left: ', 'rem;\n      margin-right: ', 'rem;\n      margin-top: ', 'rem;\n    }\n  }\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    @media (max-width:', 'px) {\n      flex-wrap: wrap;\n      > * {\n        flex-basis: 47%;\n      }\n    }\n  '], ['\n    @media (max-width:', 'px) {\n      flex-wrap: wrap;\n      > * {\n        flex-basis: 47%;\n      }\n    }\n  ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }






var getMarginFromFieldChild = function getMarginFromFieldChild(props) {
  if (!props.last) return 0;
  var fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(props.children).filter(function (c) {
    return c.type.displayName === "Field" || c.type.displayName === "EnhancedInput";
  });
  if (!fields.length) return 0;
  var lastField = fields.slice(-1)[0];
  return '-' + __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](__WEBPACK_IMPORTED_MODULE_3__form_Field__["b" /* fieldMargins */])(lastField.props);
};

var splitColumnMargins = { small: 0.5, 'default': 1, big: 2 };

var SplitColumnsContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.div(_templateObject, getMarginFromFieldChild, function (props) {
  return props.viewportMinWidth || 0;
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](splitColumnMargins)(props) / 2;
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](splitColumnMargins)(props) / 2;
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](splitColumnMargins)(props);
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](splitColumnMargins)(props) / 2;
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](splitColumnMargins)(props) / 2;
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](splitColumnMargins)(props);
}, function (props) {
  return props.twoColumnsBelowVW && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject2, function (props) {
    return props.twoColumnsBelowVW;
  });
});

var fixDoubledLastMarginBottom = function fixDoubledLastMarginBottom(children) {
  var last = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) - 1;

  function processChild(child, i) {
    if (i === last && child && child.type && child.type.displayName === SplitColumnsContainer.displayName) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, { last: true }));
    }
    return child;
  }
  if (!Array.isArray(children) || children.length === 0) {
    return processChild(children, 0);
  }
  while (!children[last] || children[last] && children[last].type && children[last].type.displayName === "Errors") {
    last--;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, processChild);
};

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_UiReducers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = { hasError: false };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(prevProps) {
      if (this.props.location !== prevProps.location) {
        this.setState({ hasError: false });
      }
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(e, info) {
      // Display fallback UI
      this.setState({ hasError: true });
      // You can also log the error to an error reporting service
      // logErrorToMyService(error, info);
      var error = e;
      try {
        JSON.stringify(e);
      } catch (exception) {
        error = e.toString();
      }
      __WEBPACK_IMPORTED_MODULE_1__reducers_UiReducers__["i" /* postFetcher */]("/log/errorBoundary", { error: error, info: info });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Error = _props.Error,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['Error', 'children']);

      if (this.state.hasError) {
        // You can render any custom fallback UI
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Error, props);
      }
      return children;
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

__WEBPACK_IMPORTED_MODULE_2_startlibs__["StartlibsProvider"].registerInternal('ErrorBoundary', ErrorBoundary);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__);
var _templateObject = _taggedTemplateLiteral(['\n    position: absolute;\n    background-color: #FFF;\n    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.4);\n    border-radius: 4px;\n    padding: 1rem;\n    text-align: initial;\n    line-height: 140%;\n    font-size: 14px;\n    z-index: 999;\n    ', '\n    ', '\n    ', '\n'], ['\n    position: absolute;\n    background-color: #FFF;\n    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.4);\n    border-radius: 4px;\n    padding: 1rem;\n    text-align: initial;\n    line-height: 140%;\n    font-size: 14px;\n    z-index: 999;\n    ', '\n    ', '\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n        margin-top: -0.25rem;\n        animation: 0.2s fadeInUp ease-out;\n    '], ['\n        margin-top: -0.25rem;\n        animation: 0.2s fadeInUp ease-out;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        margin-top: 0.25rem;\n        animation: 0.2s fadeInDown ease-out;\n    '], ['\n        margin-top: 0.25rem;\n        animation: 0.2s fadeInDown ease-out;\n    ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var PopupDiv = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.div(_templateObject, function (props) {
    return props.atTop && __WEBPACK_IMPORTED_MODULE_0_styled_components__["css"](_templateObject2);
}, function (props) {
    return props.atBottom && __WEBPACK_IMPORTED_MODULE_0_styled_components__["css"](_templateObject3);
}, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["customTheme"]("Popup"));

var Popup = __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_hocs__["WithPortal"]('Popup', true)(PopupDiv);

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dialog__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Draggable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Link__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tooltip__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loading__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SplitColumnsContainer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ErrorBoundary__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ContextMenu__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Popup__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PageLoader__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_FillLastLineResizer__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dialog", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Dialog__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultConfirmDialog", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Dialog__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConfirmDialog", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Dialog__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DraggableItem", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Draggable__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DraggableContainer", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Draggable__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_3__components_Icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_4__components_Link__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Loading", function() { return __WEBPACK_IMPORTED_MODULE_6__components_Loading__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SplitColumnsContainer", function() { return __WEBPACK_IMPORTED_MODULE_7__components_SplitColumnsContainer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fixDoubledLastMarginBottom", function() { return __WEBPACK_IMPORTED_MODULE_7__components_SplitColumnsContainer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorBoundary", function() { return __WEBPACK_IMPORTED_MODULE_8__components_ErrorBoundary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ContextMenu", function() { return __WEBPACK_IMPORTED_MODULE_9__components_ContextMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Li", function() { return __WEBPACK_IMPORTED_MODULE_9__components_ContextMenu__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListSeparator", function() { return __WEBPACK_IMPORTED_MODULE_9__components_ContextMenu__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListMenu", function() { return __WEBPACK_IMPORTED_MODULE_9__components_ContextMenu__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return __WEBPACK_IMPORTED_MODULE_10__components_Popup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PageLoader", function() { return __WEBPACK_IMPORTED_MODULE_11__components_PageLoader__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FillLastLineResizer", function() { return __WEBPACK_IMPORTED_MODULE_12__components_FillLastLineResizer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__components_Tooltip__["a"]; });
















/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export DialogIcon */
/* unused harmony export CloseIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Dialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultConfirmDialog; });
/* unused harmony export DialogError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slot_fill__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slot_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_slot_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_styled__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SplitColumnsContainer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_startlibs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ErrorBoundary__ = __webpack_require__(29);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _templateObject = _taggedTemplateLiteral(['\n    overflow-y:scroll;\n    overflow-x:hidden;\n    height:100% !important;\n    position: fixed;\n    z-index: 999;\n    top:0;\n    bottom:0;\n    left:0;\n    right:0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    background-color: rgba(0,0,0,0.5);\n    display: flex;\n    ', '\n  '], ['\n    overflow-y:scroll;\n    overflow-x:hidden;\n    height:100% !important;\n    position: fixed;\n    z-index: 999;\n    top:0;\n    bottom:0;\n    left:0;\n    right:0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    background-color: rgba(0,0,0,0.5);\n    display: flex;\n    ', '\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      padding: 3rem 0;\n    '], ['\n      padding: 3rem 0;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    border-radius: 6px;\n    padding: 2rem;\n    background-color: ', ';\n    width: 100%;\n    max-width: 45rem;\n    margin: auto;\n    position: relative;\n    align-self: baseline;\n    display: flex;\n    flex-direction: column;\n    h2 {\n      margin-bottom: 1rem;\n      padding-right: 2rem;\n      ', '\n    }\n    > h3:first-child {\n      margin-top: 0.5rem;\n    }\n    p {\n      line-height: 140%;\n    }\n    ', '\n    ', '\n    ', '\n    '], ['\n    border-radius: 6px;\n    padding: 2rem;\n    background-color: ', ';\n    width: 100%;\n    max-width: 45rem;\n    margin: auto;\n    position: relative;\n    align-self: baseline;\n    display: flex;\n    flex-direction: column;\n    h2 {\n      margin-bottom: 1rem;\n      padding-right: 2rem;\n      ', '\n    }\n    > h3:first-child {\n      margin-top: 0.5rem;\n    }\n    p {\n      line-height: 140%;\n    }\n    ', '\n    ', '\n    ', '\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        font-size: 19px;\n      '], ['\n        font-size: 19px;\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      background: #fff;\n      max-width: 46rem;\n    '], ['\n      background: #fff;\n      max-width: 46rem;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      padding: 1.5rem 1.5rem 1.5rem;\n      min-height: 100%;\n      border-radius: 0;\n      max-width: 100%;\n    '], ['\n      padding: 1.5rem 1.5rem 1.5rem;\n      min-height: 100%;\n      border-radius: 0;\n      max-width: 100%;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  font-size: 60px;\n  width: 8rem;\n  text-align: center;\n  color: #d2d2d2;\n  right: 0;\n  top: 1rem;\n  position: absolute;\n  ', '\n'], ['\n  font-size: 60px;\n  width: 8rem;\n  text-align: center;\n  color: #d2d2d2;\n  right: 0;\n  top: 1rem;\n  position: absolute;\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n      top: 50%;\n      transform: translateY(-50%);\n      margin-top: .5rem;\n    '], ['\n      top: 50%;\n      transform: translateY(-50%);\n      margin-top: .5rem;\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    font-size: 24px;\n    line-height: 32px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n    color: rgba(0,0,0,0.3);\n    transition: 0.2s linear;\n    z-index: 1000;\n    top: 1.3rem;\n    right: 1.4rem;\n    &:hover {\n      background-color: rgba(0,0,0,0.075);\n    }\n    ', '\n    ', '\n  '], ['\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    font-size: 24px;\n    line-height: 32px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n    color: rgba(0,0,0,0.3);\n    transition: 0.2s linear;\n    z-index: 1000;\n    top: 1.3rem;\n    right: 1.4rem;\n    &:hover {\n      background-color: rgba(0,0,0,0.075);\n    }\n    ', '\n    ', '\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n      top: 1rem;\n      right: 0.75rem;\n    '], ['\n      top: 1rem;\n      right: 0.75rem;\n    ']),
    _templateObject11 = _taggedTemplateLiteral(['\n      color: white;\n      background-color: rgba(0,0,0,0.2);\n      text-shadow: 0 0 2px rgba(0,0,0,0.2);\n      :hover {\n        background-color: rgba(0,0,0,0.4);\n      }\n      :active {\n        background-color: rgba(0,0,0,0.5);\n        transition: none;\n      }\n    '], ['\n      color: white;\n      background-color: rgba(0,0,0,0.2);\n      text-shadow: 0 0 2px rgba(0,0,0,0.2);\n      :hover {\n        background-color: rgba(0,0,0,0.4);\n      }\n      :active {\n        background-color: rgba(0,0,0,0.5);\n        transition: none;\n      }\n    ']),
    _templateObject12 = _taggedTemplateLiteral(['\n    max-width: 16rem;\n    position: absolute;\n    right: 0rem;\n    bottom: -1rem;\n    ', '\n'], ['\n    max-width: 16rem;\n    position: absolute;\n    right: 0rem;\n    bottom: -1rem;\n    ', '\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n      display: none;\n    '], ['\n      display: none;\n    ']),
    _templateObject14 = _taggedTemplateLiteral(['\n    width: 100%;\n    position: relative;\n    min-height: 5rem;\n    ', '\n    ', '\n    ', '\n    ', '\n    p {\n      font-size: 13px;\n    }\n    .expired-date {\n      font-size: 12px;\n      color: ', '\n    }\n    '], ['\n    width: 100%;\n    position: relative;\n    min-height: 5rem;\n    ', '\n    ', '\n    ', '\n    ', '\n    p {\n      font-size: 13px;\n    }\n    .expired-date {\n      font-size: 12px;\n      color: ', '\n    }\n    ']),
    _templateObject15 = _taggedTemplateLiteral(['\n      border-top: 1px solid ', ';\n      padding-top: 1rem;\n    '], ['\n      border-top: 1px solid ', ';\n      padding-top: 1rem;\n    ']),
    _templateObject16 = _taggedTemplateLiteral(['\n      flex-grow: 1;\n    '], ['\n      flex-grow: 1;\n    ']),
    _templateObject17 = _taggedTemplateLiteral(['\n      padding-right: 8rem;\n      min-height: 6rem;\n    '], ['\n      padding-right: 8rem;\n      min-height: 6rem;\n    ']),
    _templateObject18 = _taggedTemplateLiteral(['\n      padding-right: 15rem;\n      ', '\n    '], ['\n      padding-right: 15rem;\n      ', '\n    ']),
    _templateObject19 = _taggedTemplateLiteral(['\n        padding-right: 1.5rem;\n      '], ['\n        padding-right: 1.5rem;\n      ']),
    _templateObject20 = _taggedTemplateLiteral(['\n    width: 100%;\n    display: flex;\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    padding-top: 1rem;\n    margin-top: 1rem;\n    align-items: stretch;\n    ', '\n    ', '\n    @media (max-width: 370px) {\n      ', ' {\n        min-width: unset;\n        padding-left: 1rem;\n        padding-right: 1rem;\n      }\n    }\n  '], ['\n    width: 100%;\n    display: flex;\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    padding-top: 1rem;\n    margin-top: 1rem;\n    align-items: stretch;\n    ', '\n    ', '\n    @media (max-width: 370px) {\n      ', ' {\n        min-width: unset;\n        padding-left: 1rem;\n        padding-right: 1rem;\n      }\n    }\n  ']),
    _templateObject21 = _taggedTemplateLiteral(['\n      border-top: 1px solid ', ';\n    '], ['\n      border-top: 1px solid ', ';\n    ']),
    _templateObject22 = _taggedTemplateLiteral(['\n      ', '\n    '], ['\n      ', '\n    ']),
    _templateObject23 = _taggedTemplateLiteral(['\n        margin-top: 0;\n      '], ['\n        margin-top: 0;\n      ']),
    _templateObject24 = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    align-self: center;\n'], ['\n    flex-grow: 1;\n    align-self: center;\n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }














var Modal = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.div(_templateObject, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].desktop(_templateObject2));

var Container = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.div(_templateObject3, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["b" /* getColor */]('gray240'), __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].mobile(_templateObject4), function (props) {
  return props.withImageHeader && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject5);
}, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].mobile(_templateObject6), __WEBPACK_IMPORTED_MODULE_8__lib_styled__["a" /* customTheme */]("Dialog"));

var DialogIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */])(_templateObject7, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].desktop(_templateObject8));

var CloseIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */]).attrs({ icon: 'x' })(_templateObject9, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].mobile(_templateObject10), function (props) {
  return props.withImageHeader && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject11);
});

var DialogIllustration = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.img(_templateObject12, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].mobile(_templateObject13));

var DialogContent = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    props,
    __WEBPACK_IMPORTED_MODULE_9__SplitColumnsContainer__["b" /* fixDoubledLastMarginBottom */](props.children),
    props.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DialogIcon, { icon: props.icon }),
    props.illustration && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DialogIllustration, { src: props.illustration })
  );
})(_templateObject14, function (props) {
  return !props.withImageHeader && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject15, props.theme.colors.gray210);
}, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].mobile(_templateObject16), function (props) {
  return props.icon && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject17);
}, function (props) {
  return props.illustration && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject18, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].mobile(_templateObject19));
}, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["b" /* getColor */]('alert'));

var DialogFooter = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.div(_templateObject20, function (props) {
  return !props.withImageHeader && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject21, props.theme.colors.gray210);
}, function (props) {
  return props.withImageHeader && __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject22, __WEBPACK_IMPORTED_MODULE_8__lib_styled__["f" /* media */].mobile(_templateObject23));
}, __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* Button */]);

var FooterAuxiliaryContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.div(_templateObject24);
var focusableSelector = "button,a,textarea,input,[contenteditable]";

var historyWentBackBeforeOpen = false;

var Dialog = (_dec = __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_hocs__["withLayers"]({
  onFirst: function onFirst() {
    window.history.pushState({ dialog: true }, '', window.location.href);
    historyWentBackBeforeOpen += 1;
    Dialog.resetNavbar(true);
  },
  onEmpty: function onEmpty() {
    if (__WEBPACK_IMPORTED_MODULE_5_icepath__["ice"].get(window.history.state, 'dialog') === true) {
      historyWentBackBeforeOpen = 1;
      window.history.back();
    }
    Dialog.resetNavbar(false);
  }
}, 'Dialog'), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Dialog, _React$Component);

  function Dialog(props) {
    _classCallCheck(this, Dialog);

    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

    _this.checkHistory = function (e) {
      if (!_this.props.layers.isTop()) return;
      if (historyWentBackBeforeOpen === 2) {
        window.history.pushState({ dialog: true }, '', window.location.href);
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_5_icepath__["ice"].get(window.history.state, 'dialog') !== true) {
        window.history.pushState({ dialog: true }, '', window.location.href);
      }
      _this.closeDialog();
    };

    _this.checkFocus = function (e) {
      if (!_this.props.layers.isTop()) return;
      if (_this.modal && !e.target.closest("." + _this.modal.className.split(" ").join("."))) {
        var nextTab = _this.modal.querySelector('[tabindex]');
        if (nextTab) nextTab.focus();
      }
    };

    _this.checkKey = function (e) {
      if (!_this.props.layers.isTop()) return;
      if (_this.modal && e.shiftKey && e.keyCode === 9 && _this.modal.querySelector('[tabindex]') === document.activeElement) {
        e.preventDefault();
        var prevTab = [].slice.call(_this.modal.querySelectorAll('[tabindex]')).reduce(function (acc, el) {
          return el.tabIndex >= acc.tabIndex ? el : acc;
        }, { tabIndex: -1 });
        if (prevTab && prevTab.focus) prevTab.focus();
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        _this.closeDialog();
      } else if (e.key === 'Enter') {
        if (e.target) {
          var target = e.target.closest(focusableSelector + ',div');
          if (target && (target.tagName.toLowerCase() !== 'input' || target.form || target.type.toLowerCase() === 'file') && target.matches(focusableSelector)) return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (_this.props.onConfirm) {
          _this.props.onConfirm();
        } else if (_this.props.form) {
          _this.props.form.connector.submitProperties();
        }
      } else if (e.key === 'ArrowLeft' && _this.props.prev) {
        _this.props.prev();
      } else if (e.key === 'ArrowRight' && _this.props.next) {
        _this.props.next();
      }
    };

    _this.checkClick = function (e) {
      if (e.target === _this.modal) {
        _this.closeDialog();
      }
    };

    _this.closeDialog = function () {
      var form = _this.props.form;
      if (form && form.hasChanged) {
        form.connector.toggleConfirmCloseDialog();
      } else {
        _this.props.closeDialog && _this.props.closeDialog();
      }
    };

    _this.prevActiveElement = document.activeElement;
    return _this;
  }

  _createClass(Dialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.checkKey);
      window.addEventListener('focusin', this.checkFocus);
      window.addEventListener('popstate', this.checkHistory);
      if (this.props.closeOnClick) {
        document.addEventListener('click', this.checkClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      window.removeEventListener('keydown', this.checkKey);
      window.removeEventListener('focusin', this.checkFocus);
      window.removeEventListener('popstate', this.checkHistory);
      if (this.props.closeOnClick) {
        document.removeEventListener('click', this.checkClick);
      }
      if (!this.props.dontRefocus && document.body.contains(this.prevActiveElement) && this.prevActiveElement.matches(focusableSelector)) {
        setTimeout(function () {
          return _this2.prevActiveElement.focus();
        }, 0);
      }
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(e, i) {
      console.log(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          closeDialog = _props.closeDialog,
          children = _props.children,
          title = _props.title,
          placement = _props.placement,
          rest = _objectWithoutProperties(_props, ['closeDialog', 'children', 'title', 'placement']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_slot_fill__["Fill"],
        { name: placement },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Modal,
          { innerRef: function innerRef(e) {
              return _this3.modal = e;
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Container,
            rest,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__ErrorBoundary__["a" /* ErrorBoundary */],
              { title: title, closeDialog: closeDialog, Error: DialogErrorContent },
              closeDialog && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon, { withImageHeader: rest.withImageHeader, onClick: this.closeDialog }),
              title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                title
              ),
              children
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_slot_fill__["Slot"], { name: "Popup-" + this.props.layerIndex })
        )
      );
    }
  }], [{
    key: 'resetNavbar',
    value: function resetNavbar(opening) {
      var body = document.body;
      !body ? process.env.NODE_ENV !== 'production' ? __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default.a(false, '') : __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default.a(false) : void 0;
      var bodyWidth = body.offsetWidth;
      if (opening) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "auto";
        bodyWidth = body.offsetWidth;
      }
      var marginRight = body.offsetWidth - bodyWidth;
      body.style.paddingRight = marginRight + 'px';
      var navbar = document.querySelectorAll('.navbar');
      if (navbar.length) {
        Array.prototype.slice.call(navbar).forEach(function (n) {
          return n.style.right = marginRight + 'px';
        });
      }
      window.dispatchEvent(new Event('resize'));
    }
  }]);

  return Dialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.defaultProps = {
  placement: 'Dialog'
}, _class2.Footer = DialogFooter, _class2.Content = DialogContent, _class2.FooterAuxiliaryContainer = FooterAuxiliaryContainer, _class2.DialogIcon = DialogIcon, _class2.CloseIcon = CloseIcon, _temp)) || _class);

var ConfirmDialog = function ConfirmDialog(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Dialog,
    _extends({}, props, {
      placement: 'Confirm-Dialog' }),
    props.children
  );
};

var DefaultConfirmDialog = function DefaultConfirmDialog(props, _ref) {
  var confirmDialogLabels = _ref.startlibs.confirmDialogLabels;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    ConfirmDialog,
    { title: confirmDialogLabels.title, closeDialog: props.onCancel,
      onConfirm: props.onConfirm },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Dialog.Content,
      { icon: 'revert' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        confirmDialogLabels.content
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Dialog.Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* Button */],
        { onClick: props.onCancel },
        confirmDialogLabels.cancel
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* Button */],
        { hover: 'success', isLoading: props.isLoading, onClick: props.onSaveInstead },
        confirmDialogLabels.confirm
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* Button */],
        { autoFocus: true, alert: true, onClick: props.onConfirm },
        confirmDialogLabels.discard
      )
    )
  );
};

DefaultConfirmDialog.contextTypes = { startlibs: function startlibs() {
    return null;
  } };

var DialogErrorContent = function DialogErrorContent(_ref2, _ref3) {
  var closeDialog = _ref2.closeDialog,
      title = _ref2.title;
  var _ref3$startlibs$Error = _ref3.startlibs.ErrorDialog,
      content = _ref3$startlibs$Error.content,
      close = _ref3$startlibs$Error.close;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Dialog.Content,
      { icon: 'warning' },
      content
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Dialog.Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* Button */],
        { onClick: closeDialog },
        close
      )
    )
  );
};

var DialogError = function DialogError(_ref4, _ref5) {
  var closeDialog = _ref4.closeDialog;
  var _ref5$startlibs$Error = _ref5.startlibs.ErrorDialog,
      title = _ref5$startlibs$Error.title,
      content = _ref5$startlibs$Error.content,
      close = _ref5$startlibs$Error.close;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Dialog,
    {
      closeDialog: closeDialog,
      title: title
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DialogErrorContent, { closeDialog: closeDialog })
  );
};

DialogError.contextTypes = DialogErrorContent.contextTypes = { startlibs: function startlibs() {
    return null;
  } };

__WEBPACK_IMPORTED_MODULE_10_startlibs__["StartlibsProvider"].registerInternal('DialogError', DialogError);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DraggableItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraggableContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _class2, _temp4;

var _templateObject = _taggedTemplateLiteral(['\n  border: 2px dashed rgba(0,0,0,0.1);\n  background-color: rgba(0,0,0,0.025);\n  border-radius: 4px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  visibility: visible;\n  display: block;\n'], ['\n  border: 2px dashed rgba(0,0,0,0.1);\n  background-color: rgba(0,0,0,0.025);\n  border-radius: 4px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  visibility: visible;\n  display: block;\n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }








var DropPosition = __WEBPACK_IMPORTED_MODULE_4_styled_components___default.a.div(_templateObject);

var HORIZONTAL_DIMENSIONS = {
  min: 'left',
  max: 'right',
  axis: 'x',
  size: 'Width'
};
var VERTICAL_DIMENSIONS = {
  min: 'top',
  max: 'bottom',
  axis: 'y',
  size: 'Height'
};

var getScrollParent = function getScrollParent(node) {
  if (!node) {
    return window;
  }
  var overflowY = window.getComputedStyle(node).overflowY;
  var isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';
  if (isScrollable && (node.scrollHeight > node.clientHeight || overflowY === 'scroll')) {
    return node;
  } else {
    return getScrollParent(node.offsetParent);
  }
};

var AUTO_SCROLL_BORDER_SIZE = 30;
var AUTO_SCROLL_MAX_VELOCITY = 20;
var AUTO_SCROLL_OVERFLOW_BUFFER = 100;

function easeInCubic(t) {
  return Math.ceil(t * t * t / (AUTO_SCROLL_MAX_VELOCITY * AUTO_SCROLL_MAX_VELOCITY));
}

var shouldPreventDrag = function shouldPreventDrag(e) {
  return !e.target.closest('body,.drag-drop-item,[data-drag="false"],input,textarea,button').matches('body,.drag-drop-item,[data-drag="true"]');
};

var DraggableItem = (_temp2 = _class = function (_React$Component) {
  _inherits(DraggableItem, _React$Component);

  function DraggableItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DraggableItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableItem.__proto__ || Object.getPrototypeOf(DraggableItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.positions = {}, _this.passedResistance = false, _this.pressedEnough = false, _this.dragStart = function (currentTarget, pageX, pageY, clientX, clientY, e) {
      if (shouldPreventDrag(e)) {
        return;
      }
      if (e.type === "mousedown" && e.button !== 0) {
        return;
      }
      e.stopPropagation();
      _this.passedResistance = false;
      var holdTouchTimer = _this.context.dragProps.holdTouchTimer;
      _this.pressedEnough = !holdTouchTimer;
      if (holdTouchTimer) {
        e.persist();
        _this.holdTouchTimer = setTimeout(function () {
          _this.pressedEnough = true;
          if (window.navigator.vibrate) window.navigator.vibrate([65]);
          if (!_this.state.isDragging) {
            _this.dragMove(currentTarget, pageX, pageY, clientX, clientY, e);
          }
        }, holdTouchTimer);
      }

      var _currentTarget$getBou = currentTarget.getBoundingClientRect(),
          width = _currentTarget$getBou.width,
          height = _currentTarget$getBou.height,
          top = _currentTarget$getBou.top,
          left = _currentTarget$getBou.left;

      var targetStyle = window.getComputedStyle(currentTarget);

      var _this$context$dragPro = _this.context.dragProps.getParentDimensions(),
          parentTop = _this$context$dragPro.top,
          parentLeft = _this$context$dragPro.left;

      var offsetTop = parentTop + pageY - top + parseInt(targetStyle['margin-top'], 10);
      var offsetLeft = parentLeft + pageX - left + parseInt(targetStyle['margin-left'], 10);

      var _this$context$dragPro2 = _this.context.dragProps.getScrollContainer(),
          scrollTop = _this$context$dragPro2.scrollTop,
          scrollLeft = _this$context$dragPro2.scrollLeft;

      _this.positions = {
        originalX: pageX, originalY: pageY,
        offsetTop: offsetTop, offsetLeft: offsetLeft, ghostHeight: height, ghostWidth: width,
        ghostMarginTop: parseInt(targetStyle['margin-top'], 10),
        ghostMarginLeft: parseInt(targetStyle['margin-left'], 10),
        scrollLeft: scrollLeft || 0, scrollTop: scrollTop || 0
      };

      var ghost = _this.ghostElement = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this).cloneNode(true);
      ghost.className += ' dragging';
      Object.assign(ghost.style, {
        position: 'absolute', display: 'none', zIndex: '10', width: width + 'px', height: height + 'px', margin: '0',
        top: currentTarget.offsetTop + 'px', left: currentTarget.offsetLeft + 'px'
      });

      _this.context.dragProps.setupMove(ghost, _this, { width: width, height: height, offsetX: pageX - left, offsetY: pageY - top });
      window.addEventListener('mousemove', _this.mouseMove);
      window.addEventListener('touchmove', _this.touchMove, { passive: false });
      window.addEventListener('mouseup', _this.dragEnd);
      window.addEventListener('touchend', _this.dragEnd);
      window.addEventListener('visibilitychange', _this.dragEnd);
      window.addEventListener('blur', _this.dragEnd, false);
      window.addEventListener('selectstart', _this.disableSelect);
    }, _this.dragMove = function (currentTarget, pageX, pageY, clientX, clientY, e) {
      var distance = Math.sqrt(Math.pow(_this.positions.originalX - pageX, 2) + Math.pow(_this.positions.originalY - pageY, 2));
      if (e.type === 'mousemove') {
        // get touchstart and touchmove
        if (!_this.passedResistance && !_this.context.dragProps.noResistance && distance < 5) {
          return;
        }
      } else {
        if (!_this.pressedEnough) {
          if (distance > 5) {
            _this.dragEnd();
          }
          return;
        }
        e.preventDefault();
      }
      _this.passedResistance = true;

      _this.processAutoScroll(pageX, pageY, clientX, clientY);
    }, _this.completeMove = function (pageX, pageY) {
      var _this$context$dragPro3 = _this.context.dragProps.getScrollContainer(),
          scrollTop = _this$context$dragPro3.scrollTop,
          scrollLeft = _this$context$dragPro3.scrollLeft;

      var scrollYDelta = _this.positions.scrollTop - (scrollTop || 0);
      var scrollXDelta = _this.positions.scrollLeft - (scrollLeft || 0);
      var ghostLeft = pageX - _this.positions.offsetLeft;
      var ghostTop = pageY - _this.positions.offsetTop;

      var _this$context$dragPro4 = _this.context.dragProps.getParentDimensions(),
          parentHeight = _this$context$dragPro4.height,
          parentWidth = _this$context$dragPro4.width;

      var normalizedLeft = Math.max(Math.min(ghostLeft, parentWidth - _this.positions.ghostWidth - _this.positions.ghostMarginLeft + scrollXDelta), 0 - _this.positions.ghostMarginLeft + scrollXDelta);
      var normalizedTop = Math.max(Math.min(ghostTop, parentHeight - _this.positions.ghostHeight - _this.positions.ghostMarginTop + scrollYDelta), 0 - _this.positions.ghostMarginTop + scrollYDelta);
      var x = normalizedLeft - ghostLeft + pageX - _this.positions.originalX - scrollXDelta;
      var y = normalizedTop - ghostTop + pageY - _this.positions.originalY - scrollYDelta;
      if (_this.ghostElement) {
        _this.ghostElement.style.transform = 'translate(' + x + 'px,' + y + 'px)' + (_this.props.ghostScale ? ' scale(' + _this.props.ghostScale + ')' : '');
        _this.ghostElement.style.display = '';
      }
      _this.context.dragProps.move(pageX - (ghostLeft - normalizedLeft), pageY - (ghostTop - normalizedTop));
      if (!_this.state.isDragging) _this.setState({ isDragging: true });
    }, _this.getFixedParentRect = function (node) {
      if (node) {
        if (window.getComputedStyle(node)['position'].toLowerCase() === 'fixed') return node.getBoundingClientRect();else return _this.getFixedParentRect(node.offsetParent);
      } else {
        return {};
      }
    }, _this.calculateDistanceFromBorder = function (position, getElementBeforeBorder, scrollContainer, parentRect, keys) {
      var fixedUnderMouse = scrollContainer === window ? _this.getFixedParentRect(getElementBeforeBorder(+AUTO_SCROLL_BORDER_SIZE)) : {};
      var min = scrollContainer !== window ? scrollContainer.getBoundingClientRect()[keys.min] : fixedUnderMouse[keys.max] || _this.getFixedParentRect(getElementBeforeBorder(-AUTO_SCROLL_BORDER_SIZE))[keys.max] || 0;
      var max = scrollContainer !== window ? scrollContainer.getBoundingClientRect()[keys.max] : fixedUnderMouse[keys.min] || _this.getFixedParentRect(getElementBeforeBorder(+AUTO_SCROLL_BORDER_SIZE))[keys.min] || window['inner' + keys.size];
      var distanceMin = position - AUTO_SCROLL_BORDER_SIZE - min;
      var distanceMax = position + AUTO_SCROLL_BORDER_SIZE - max;

      var containerMin = scrollContainer === window ? 0 : Math.max(scrollContainer.getBoundingClientRect()[keys.min], 0);
      var containerMax = scrollContainer === window ? window['inner' + keys.size] : Math.min(scrollContainer.getBoundingClientRect()[keys.max], window['inner' + keys.size]);
      var afterCenter = (position - containerMin) * 2 / (containerMax - containerMin) > 1;
      if (distanceMin < 0 && !afterCenter) return distanceMin;
      if (distanceMax > 0) return distanceMax;
      return 0;
    }, _this.processAutoScroll = function (pageX, pageY, clientX, clientY) {
      var scrollContainer = _this.context.dragProps.getScrollContainer();
      var parentRect = _this.context.dragProps.getParentDimensions();
      _this.autoScrollY = _this.calculateDistanceFromBorder(clientY, function (diff) {
        return document.elementFromPoint(clientX, clientY + diff);
      }, scrollContainer, parentRect, VERTICAL_DIMENSIONS);
      // this.autoScrollX = this.calculateDistanceFromBorder(clientX, (diff) => document.elementFromPoint(clientX + diff, clientY), scrollContainer, parentRect, HORIZONTAL_DIMENSIONS)
      _this.autoScrollX = 0;
      var keepY = _this.autoScrollX === 0 || _this.autoScrollY !== 0 && Math.abs(_this.autoScrollY) < Math.abs(_this.autoScrollX);

      _this.autoScrollY = _this.context.dragProps.scrollOnDrag() && keepY ? _this.autoScrollY : 0;
      _this.autoScrollX = _this.context.dragProps.scrollOnDrag() && !keepY ? _this.autoScrollX : 0;

      if (_this.autoScrollX || _this.autoScrollY) {
        _this.startAutoScroll(pageX, pageY, scrollContainer);
      } else {
        if (_this.autoScrollAnimation) {
          _this.stopAutoScroll();
        }
        _this.completeMove(pageX, pageY);
      }
    }, _this.checkLimits = function (delta, boundRect, constraintRect, scrollRect, keys) {
      if (delta > 0) {
        if (constraintRect[keys.max] + AUTO_SCROLL_OVERFLOW_BUFFER < scrollRect[keys.max]) {
          return 0;
        }
      }
      if (delta < 0) {
        if (constraintRect[keys.min] - AUTO_SCROLL_OVERFLOW_BUFFER > scrollRect[keys.min]) {
          return 0;
        }
      }
      return delta;
    }, _this.startAutoScroll = function (pageX, pageY, scrollContainer) {
      if (!_this.autoScrollAnimation) {
        _this.autoScrollAnimation = window.requestAnimationFrame(function (timestamp) {
          var ghostRect = _this.ghostElement.getBoundingClientRect();
          var parentRect = _this.context.dragProps.getParentDimensions();
          var scrollRect = scrollContainer === window ? { top: 0, bottom: window.innerHeight, left: 0, right: window.innerWidth } : scrollContainer.getBoundingClientRect();
          var deltaScrollX = easeInCubic(_this.checkLimits(_this.autoScrollX < 0 ? Math.max(_this.autoScrollX, -AUTO_SCROLL_MAX_VELOCITY) : Math.min(_this.autoScrollX, AUTO_SCROLL_MAX_VELOCITY), ghostRect, parentRect, scrollRect, HORIZONTAL_DIMENSIONS));
          var deltaScrollY = easeInCubic(_this.checkLimits(_this.autoScrollY < 0 ? Math.max(_this.autoScrollY, -AUTO_SCROLL_MAX_VELOCITY) : Math.min(_this.autoScrollY, AUTO_SCROLL_MAX_VELOCITY), ghostRect, parentRect, scrollRect, VERTICAL_DIMENSIONS));

          var willScroll = deltaScrollX !== 0 || deltaScrollY !== 0;
          if (willScroll) {
            scrollContainer.scroll((isNaN(scrollContainer.scrollLeft) ? scrollContainer.pageXOffset : scrollContainer.scrollLeft) + deltaScrollX, (isNaN(scrollContainer.scrollTop) ? scrollContainer.pageYOffset : scrollContainer.scrollTop) + deltaScrollY);
          }

          _this.autoScrollAnimation = 0;
          _this.completeMove(pageX, pageY);
          if (willScroll) {
            _this.startAutoScroll(pageX + (scrollContainer === window ? deltaScrollX : 0), pageY + (scrollContainer === window ? deltaScrollY : 0), scrollContainer);
          }
        });
      } else {
        _this.completeMove(pageX, pageY);
      }
    }, _this.stopAutoScroll = function () {
      window.cancelAnimationFrame(_this.autoScrollAnimation);
      _this.autoScrollAnimation = 0;
    }, _this.dragEnd = function () {
      window.removeEventListener('touchmove', _this.touchMove);
      window.removeEventListener('mousemove', _this.mouseMove);
      window.removeEventListener('mouseup', _this.dragEnd);
      window.removeEventListener('touchend', _this.dragEnd);
      window.removeEventListener('visibilitychange', _this.dragEnd);
      window.removeEventListener('blur', _this.dragEnd);
      window.removeEventListener('selectstart', _this.disableSelect);
      _this.ghostElement = null;
      _this.stopAutoScroll();
      _this.props.setDragRef && _this.props.setDragRef(null);
      clearTimeout(_this.holdTouchTimer);
      _this.setState({ isDragging: false });
      _this.context.dragProps.stopMoving();
    }, _this.mouseDown = __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["normalizeMouse"](_this.dragStart), _this.mouseMove = __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["normalizeMouse"](_this.dragMove), _this.touchStart = __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["normalizeTouch"](_this.dragStart, _this.dragEnd), _this.touchMove = __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["normalizeTouch"](_this.dragMove, _this.dragEnd), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DraggableItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.context.dragProps.addItem(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.context.dragProps.removeItem(this);
    }
  }, {
    key: 'disableSelect',
    value: function disableSelect(event) {
      event.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          TagName = _props.DragTag,
          className = _props.className,
          index = _props.index,
          ghostScale = _props.ghostScale,
          id = _props.id,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['DragTag', 'className', 'index', 'ghostScale', 'id', 'children']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        TagName,
        _extends({}, rest, {
          onMouseDown: this.mouseDown,
          onTouchStart: this.touchStart,
          className: className + (this.state.isDragging ? ' drag-drop-placeholder' : '') + ' drag-drop-item'
        }),
        children,
        this.state.isDragging && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropPosition, null)
      );
    }
  }]);

  return DraggableItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.defaultProps = { DragTag: 'div' }, _class.contextTypes = {
  dragProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
}, _temp2);

DraggableItem.a = function (_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ['children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    DraggableItem,
    _extends({}, props, { DragTag: 'a' }),
    children
  );
};

var DraggableContainer = (_temp4 = _class2 = function (_React$Component2) {
  _inherits(DraggableContainer, _React$Component2);

  function DraggableContainer() {
    var _ref3;

    var _temp3, _this2, _ret2;

    _classCallCheck(this, DraggableContainer);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = _possibleConstructorReturn(this, (_ref3 = DraggableContainer.__proto__ || Object.getPrototypeOf(DraggableContainer)).call.apply(_ref3, [this].concat(args))), _this2), _this2.state = { newIndex: -1 }, _this2.preventDefault = function (e) {
      if (!shouldPreventDrag(e) && _this2.preventScroll) e.preventDefault();
    }, _this2.domItems = [], _this2.setOffsetParent = function (e) {
      _this2.parent = e;
      _this2.offsetParent = e ? e.firstChild ? e.firstChild.offsetParent : e.parentNode : e;
    }, _this2.getDimensions = function () {
      if (!_this2.offsetParent) return { left: 0, top: 0, bottom: 0, right: 0, width: 0, height: 0 };
      return _this2.offsetParent.getBoundingClientRect();
    }, _this2.addItem = function (el) {
      _this2.domItems = _this2.domItems.concat(el);
    }, _this2.removeItem = function (el) {
      _this2.domItems = _this2.domItems.filter(function (e) {
        return e !== el;
      });
    }, _this2.settedDragRef = false, _this2.setupMove = function (el, item, ghostDimensions) {
      _this2.ghostDimensions = ghostDimensions;
      _this2.offsetParent.click(); // close popups
      _this2.ghost = el;
      _this2.draggingItemIndex = typeof item.props.index === 'number' ? item.props.index : _this2.props.children.findIndex(function (i) {
        return i.props === item.props;
      });
      _this2.setState({ newIndex: _this2.draggingItemIndex });
      _this2.settedDragRef = false;
      _this2.parent.appendChild(_this2.ghost);
      _this2.setupPositions();
    }, _this2.setupPositions = function () {
      var _this2$scrollContaine = _this2.scrollContainer,
          scrollTop = _this2$scrollContaine.scrollTop,
          scrollLeft = _this2$scrollContaine.scrollLeft;

      _this2.itemsPositions = _this2.props.children.reduce(function (acc, child) {
        var domItem = _this2.domItems.find(function (item) {
          return item.props.index === acc.length || item.props === child.props;
        });
        if (domItem) {
          var _getBoundingClientRec = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(domItem).getBoundingClientRect(),
              _width = _getBoundingClientRec.width,
              _height = _getBoundingClientRec.height,
              top = _getBoundingClientRec.top,
              left = _getBoundingClientRec.left;

          return acc.concat({
            index: acc.length,
            y: top + _height / 2 + (scrollTop || 0),
            x: left + _width / 2 + (scrollLeft || 0)
          });
        } else {
          return acc;
        }
      }, []);
    }, _this2.move = function (x, y) {
      if (!_this2.settedDragRef && _this2.props.setDragRef) {
        _this2.props.setDragRef(_this2.ghost);
        _this2.settedDragRef = true;
      }
      var _this2$scrollContaine2 = _this2.scrollContainer,
          scrollTop = _this2$scrollContaine2.scrollTop,
          scrollLeft = _this2$scrollContaine2.scrollLeft;

      _this2.preventScroll = true;
      var index = _this2.findGhostIndex(x - _this2.ghostDimensions.offsetX + (scrollLeft || 0), y - _this2.ghostDimensions.offsetY + (scrollTop || 0));
      if (index < 0) {
        return;
      }
      if (index !== _this2.state.newIndex) {
        _this2.setState({ newIndex: index });
      }
    }, _this2.findGhostIndex = function (x, y) {
      return _this2.itemsPositions.findIndex(function (position) {
        return position.y >= y && position.x >= x && position.y <= y + _this2.ghostDimensions.height && position.x <= x + _this2.ghostDimensions.width;
      });
    }, _this2.stopMoving = function () {
      _this2.preventScroll = false;
      _this2.props.setDragRef(null);
      _this2.settedDragRef = false;
      _this2.parent.removeChild(_this2.ghost);
      if (_this2.state.newIndex !== _this2.draggingItemIndex) {
        var promise = _this2.props.setItemOrder(_this2.draggingItemIndex, _this2.state.newIndex);
        if (promise && promise.then) {
          promise.then(_this2.clearChangedOrder, _this2.clearChangedOrder);
        } else {
          _this2.clearChangedOrder();
        }
      } else {
        _this2.clearChangedOrder();
      }
    }, _this2.clearChangedOrder = function () {
      return _this2.setState({ newIndex: -1 });
    }, _temp3), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(DraggableContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollContainer = this.props.scrollContainer ? this.props.scrollContainer : getScrollParent(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this));
      this.parent.addEventListener('touchmove', this.preventDefault);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.parent.removeEventListener('touchmove', this.preventDefault);
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var _this3 = this;

      return {
        dragProps: {
          noResistance: this.props.noResistance,
          holdTouchTimer: this.props.holdTouchTimer,
          move: this.move,
          stopMoving: this.stopMoving,
          setupMove: this.setupMove,
          getParentDimensions: this.getDimensions,
          addItem: this.addItem,
          scrollOnDrag: function scrollOnDrag() {
            return _this3.props.scrollOnDrag;
          },
          getScrollContainer: function getScrollContainer() {
            return _this3.scrollContainer;
          },
          removeItem: this.removeItem
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!isNaN(this.lastScrollTop) || !isNaN(this.lastScrollLeft)) {
        this.scrollContainer.scroll(this.lastScrollLeft, this.lastScrollTop);
        this.lastScrollLeft = this.lastScrollTop = undefined;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          setItemOrder = _props2.setItemOrder,
          noResistance = _props2.noResistance,
          setDragRef = _props2.setDragRef,
          scrollOnDrag = _props2.scrollOnDrag,
          holdTouchTimer = _props2.holdTouchTimer,
          children = _props2.children,
          rest = _objectWithoutProperties(_props2, ['setItemOrder', 'noResistance', 'setDragRef', 'scrollOnDrag', 'holdTouchTimer', 'children']);

      var newIndex = this.state.newIndex;

      var sortedChildren = children;
      if (newIndex >= 0) {
        var array = children;
        sortedChildren = __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"](array).splice(this.draggingItemIndex, 1).splice(newIndex, 0, array[this.draggingItemIndex]).value();
      }
      if (this.scrollContainer) {
        this.lastScrollTop = (isNaN(this.scrollContainer['scrollTop']) ? this.scrollContainer['pageYOffset'] : this.scrollContainer['scrollTop']) || undefined;
        this.lastScrollLeft = (isNaN(this.scrollContainer['scrollLeft']) ? this.scrollContainer['pageXOffset'] : this.scrollContainer['scrollLeft']) || undefined;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, rest, { ref: this.setOffsetParent }),
        sortedChildren
      );
    }
  }]);

  return DraggableContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.defaultProps = {
  holdTouchTimer: 300,
  scrollOnDrag: true,
  setDragRef: function setDragRef() {}
}, _class2.childContextTypes = {
  dragProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
}, _temp4);

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_42__;

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _templateObject = _taggedTemplateLiteral(['\n  ', ' \n  \n'], ['\n  ', ' \n  \n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position:absolute;\n    top:0;\n    left:0;\n    bottom:0;\n    right:0;\n    ', '\n  '], ['\n    position:absolute;\n    top:0;\n    left:0;\n    bottom:0;\n    right:0;\n    ', '\n  ']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }






var TooltipContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.div(_templateObject, function (props) {
  return props.isWrapper ? 'position:relative;' : __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject2, function (props) {
    return props.isOpen && 'pointer-events: none;';
  });
});

var Tooltip = (_dec = __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_hocs__["withToggles"]('tooltip'), _dec(_class = function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.mouseEnter = function (e) {
      _this.props.tooltip.open();
      !_this.props.children && e.currentTarget.parentNode.addEventListener('mouseleave', _this.mouseLeave);
    }, _this.mouseLeave = function (e) {
      !_this.props.children && e.currentTarget.removeEventListener('mouseleave', _this.mouseLeave);
      _this.props.tooltip.close();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          tooltip = _props.tooltip,
          content = _props.content,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['tooltip', 'content', 'children']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        TooltipContainer,
        { isOpen: tooltip.isOpen, isWrapper: !!children, onMouseLeave: children ? tooltip.close : undefined, onMouseEnter: this.mouseEnter },
        tooltip.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Popup__["a" /* Popup */],
          _extends({ arrow: true, top: !(rest.bottom || rest.left || rest.right || rest.at || rest.my) }, rest),
          content
        ),
        children
      );
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ListMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ListSeparator; });
/* unused harmony export SimpleLi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Li; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Link__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mitt__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mitt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mitt__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _dec, _class2, _class3, _temp4, _dec2, _class4, _class5, _temp5;

var _templateObject = _taggedTemplateLiteral(['\n    padding: 0.5rem 0;\n    cursor: default;\n    overflowY: auto;\n    text-align: left;\n    color: inherit;\n    user-select: none;\n'], ['\n    padding: 0.5rem 0;\n    cursor: default;\n    overflowY: auto;\n    text-align: left;\n    color: inherit;\n    user-select: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  z-index: 999;\n  background-color: #FFF;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.4);\n  border-radius: 2px;\n  margin-bottom: 0.5rem;\n  white-space: nowrap;\n\n  ', '\n\n  ', '\n  ', '\n'], ['\n  position: absolute;\n  z-index: 999;\n  background-color: #FFF;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.4);\n  border-radius: 2px;\n  margin-bottom: 0.5rem;\n  white-space: nowrap;\n\n  ', '\n\n  ', '\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    ', '\n\n    ', '\n\n    ', '\n  '], ['\n    ', '\n\n    ', '\n\n    ', '\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    border-bottom: 1px solid rgba(0,0,0,0.1);\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n    cursor: default;\n    height: 0;\n'], ['\n    border-bottom: 1px solid rgba(0,0,0,0.1);\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n    cursor: default;\n    height: 0;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: relative;\n  & > * {\n    padding: 11px 3rem;\n    display: block;\n  }\n  & > a {\n    color: inherit;\n    font-weight: inherit;\n    text-decoration: inherit;\n  }\n  & > a, & > label {\n    cursor: pointer;\n  }\n  ', '\n  ', '\n  ', ', .icon {\n    font-size: 23px;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 3rem;\n    text-align: center;\n  }\n  input[type="radio"] {\n    display: none;\n  }\n  ', '\n  ', '\n'], ['\n  position: relative;\n  & > * {\n    padding: 11px 3rem;\n    display: block;\n  }\n  & > a {\n    color: inherit;\n    font-weight: inherit;\n    text-decoration: inherit;\n  }\n  & > a, & > label {\n    cursor: pointer;\n  }\n  ', '\n  ', '\n  ', ', .icon {\n    font-size: 23px;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 3rem;\n    text-align: center;\n  }\n  input[type="radio"] {\n    display: none;\n  }\n  ', '\n  ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    color: ', ';\n  '], ['\n    color: ', ';\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  font-size: 13px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3rem;\n  text-align: center;\n'], ['\n  font-size: 13px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3rem;\n  text-align: center;\n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }











var ListMenu = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.ul(_templateObject);

var ContextListMenu = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a(ListMenu)(_templateObject2, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["ifProp"]('atBottom', 'animation: 0.2s fadeInDown ease-out;', 'animation: 0.2s fadeInUp ease-out;'), __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["ifProp"]('sub', __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"](_templateObject3, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["ifProp"]('atTop', 'margin-top: -0.5rem;', 'margin-top: 0.5rem;'), __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["ifProp"]('atRight', '\n      margin-left: -2px;\n      animation: 0.2s fadeInRight ease-out;\n      ', '\n      margin-left: 2px;\n      animation: 0.2s fadeInLeft ease-out;\n    '), function (props) {
  return props.closing === 2 && '\n      opacity:0;\n      transition: opacity 0.5s ease-out;\n    ';
})), __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["customTheme"]("ContextMenu"));

var ListSeparator = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.li(_templateObject4);

var ListItem = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.li(_templateObject5, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["ifProp"]('hover', '& > a, & > label {\n    background-color: rgba(0,0,0,0.1);\n  }'), __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["ifProp"]('highlight', __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"](_templateObject6, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('main'))), __WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* Icon */], __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["ifProp"]('noActions', '\n    max-width: 17rem;\n    color: rgba(0,0,0,0.4);\n    pointer-events: none;\n    text-align: center;\n    white-space: normal;\n  '), __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["customTheme"]("ListItem"));

var SubmenuArrowIcon = __WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* Icon */].extend(_templateObject7);

var layerCursor = 0;

var SimpleLi = (_temp2 = _class = function (_React$Component) {
  _inherits(SimpleLi, _React$Component);

  function SimpleLi() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SimpleLi);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleLi.__proto__ || Object.getPrototypeOf(SimpleLi)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToVisibility = function () {
      var el = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);
      var list = el.parentNode;
      if (el.offsetTop < list.scrollTop) {
        list.scrollTop = el.offsetTop;
      } else if (el.offsetTop + el.offsetHeight > list.scrollTop + list.offsetHeight) {
        list.scrollTop = el.offsetTop + el.offsetHeight - list.offsetHeight;
      }
    }, _this.confirm = function () {
      if (_this.props.hover) {
        var node = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);
        node.click();
      }
    }, _this.onMouseEnter = function () {
      return _this.props.setCursorOnHover && _this.props.setCursorOnHover(_this.props.index);
    }, _this.onMouseOut = function () {
      return _this.props.setCursorOnHover && _this.props.setCursorOnHover(-1);
    }, _this.touchEnd = function (e) {
      if (_this.props.children) {
        e.preventDefault();
        if (!_this.props.hover) _this.onMouseEnter();
      }
    }, _this.onClick = function (e) {
      _this.props.onClick && _this.props.onClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SimpleLi, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.emitter.on('confirm', this.confirm);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.emitter.off('confirm', this.confirm);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.hover) {
        this.scrollToVisibility();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.selected && this.props.setCursorOnHover) {
        this.props.setCursorOnHover(this.props.index);
        var el = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);
        var list = el.parentNode;
        list.scrollTop = el.offsetTop + el.offsetHeight / 2 - list.offsetHeight / 2;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          layerIndex = _props.layerIndex,
          href = _props.href,
          skipTo = _props.skipTo,
          linkTo = _props.linkTo,
          prefixWith = _props.prefixWith,
          subMenu = _props.subMenu,
          icon = _props.icon,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['label', 'layerIndex', 'href', 'skipTo', 'linkTo', 'prefixWith', 'subMenu', 'icon', 'children']);

      var Tag = linkTo || skipTo ? __WEBPACK_IMPORTED_MODULE_7__Link__["a" /* Link */] : 'a';
      var skipOnLink = Tag === 'a' ? {} : { skipTo: skipTo };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ListItem,
        _extends({}, rest, {
          onClick: this.onClick,
          onMouseLeave: this.onMouseOut,
          onMouseEnter: this.onMouseEnter,
          onTouchEnd: this.touchEnd
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Tag,
          _extends({ href: href, to: linkTo || skipTo }, skipOnLink),
          prefixWith,
          icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* Icon */], { icon: icon }),
          label
        )
      );
    }
  }]);

  return SimpleLi;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.isKeyboardNavigable = true, _class.defaultProps = {
  emitter: __WEBPACK_IMPORTED_MODULE_8_mitt___default.a()
}, _temp2);

var Li = (_dec = __WEBPACK_IMPORTED_MODULE_2_recompose__["hoistStatics"](__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["withToggles"]('subMenu')), _dec(_class2 = (_temp4 = _class3 = function (_React$Component2) {
  _inherits(Li, _React$Component2);

  function Li() {
    var _ref2;

    var _temp3, _this2, _ret2;

    _classCallCheck(this, Li);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Li.__proto__ || Object.getPrototypeOf(Li)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = { keepSub: false }, _this2.subPrevented = false, _this2.confirm = function () {
      if (_this2.props.hover) {
        var node = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this2);
        node.click();
      }
    }, _this2.onMouseEnter = function () {
      return _this2.props.setCursorOnHover && _this2.props.setCursorOnHover(_this2.props.index);
    }, _this2.onMouseOut = function () {
      return _this2.props.setCursorOnHover && _this2.props.setCursorOnHover(-1);
    }, _this2.touchEnd = function (e) {
      if (_this2.props.children) {
        e.preventDefault();
        if (_this2.props.hover) _this2.props.subMenu.toggle();else _this2.onMouseEnter();
      }
    }, _this2.onClick = function (e) {
      if (_this2.props.children) {
        e.stopPropagation();
      }
      _this2.props.onClick && _this2.props.onClick();
    }, _this2.onCloseSub = function () {
      return _this2.props.emitter.emit('openSub');
    }, _this2.addProps = function (children) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (c) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(c, _extends({}, c.props, {
          closing: _this2.props.subMenu.closing,
          onMouseMove: _this2.props.subMenu.open,
          onClose: _this2.onCloseSub,
          sub: true
        }));
      });
    }, _temp3), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(Li, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      this.props.emitter.on('confirm', this.confirm);
      this.props.emitter.on('preventSub', function (index) {
        if (_this3.props.index !== index) _this3.props.subMenu.close();
        _this3.subPrevented = true;
      });
      this.props.emitter.on('openSub', function () {
        _this3.subPrevented = false;
        if (_this3.props.hover && _this3.props.children) {
          _this3.props.subMenu.open();
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.emitter.off('confirm', this.confirm);
      this.props.subMenu.close();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref3) {
      var hover = _ref3.hover,
          hoverCursor = _ref3.hoverCursor;

      if (this.props.hoverCursor !== hoverCursor && this.props.children) {
        if (hover) {
          if (this.props.subMenu.isOpen || !this.subPrevented) {
            this.props.subMenu.open();
          }
        } else {
          if (this.props.subMenu.isOpen) {
            this.props.subMenu.closeAfter(200, 300)();
            this.props.emitter.emit('preventSub', this.props.index);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          label = _props2.label,
          layerIndex = _props2.layerIndex,
          href = _props2.href,
          skipTo = _props2.skipTo,
          linkTo = _props2.linkTo,
          prefixWith = _props2.prefixWith,
          subMenu = _props2.subMenu,
          icon = _props2.icon,
          children = _props2.children,
          rest = _objectWithoutProperties(_props2, ['label', 'layerIndex', 'href', 'skipTo', 'linkTo', 'prefixWith', 'subMenu', 'icon', 'children']);

      var Tag = linkTo || skipTo ? __WEBPACK_IMPORTED_MODULE_7__Link__["a" /* Link */] : 'a';
      var skipOnLink = Tag === 'a' ? {} : { skipTo: skipTo };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ListItem,
        _extends({}, rest, {
          onClick: this.onClick,
          onMouseLeave: this.onMouseOut,
          onMouseEnter: this.onMouseEnter,
          onTouchEnd: this.touchEnd
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Tag,
          _extends({ href: href, to: linkTo || skipTo }, skipOnLink),
          prefixWith,
          icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* Icon */], { icon: icon }),
          label,
          children && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubmenuArrowIcon, { icon: 'arrow-right' })
        ),
        subMenu.isOpen && this.addProps(children)
      );
    }
  }]);

  return Li;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class3.isKeyboardNavigable = true, _class3.defaultProps = {
  emitter: __WEBPACK_IMPORTED_MODULE_8_mitt___default.a()
}, _class3.Simple = SimpleLi, _temp4)) || _class2);

var ContextMenu = void 0;

var ContextMenuComponent = (_dec2 = __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["WithPortal"]('Popup', true), _dec2(_class4 = (_temp5 = _class5 = function (_React$Component3) {
  _inherits(ContextMenuComponent, _React$Component3);

  function ContextMenuComponent(props) {
    _classCallCheck(this, ContextMenuComponent);

    var _this4 = _possibleConstructorReturn(this, (ContextMenuComponent.__proto__ || Object.getPrototypeOf(ContextMenuComponent)).call(this, props));

    _this4.keydown = function (e) {
      if (e.keyCode === 37 || e.keyCode === 39) {
        if (!e.defaultPrevented) {
          var direction = e.keyCode - 38;
          layerCursor = (layerCursor + direction + ContextMenu.layers()) % ContextMenu.layers();
          _this4.props.groupEvent.emit('layerUpdate');
        }
        e.preventDefault();
      }
      if (_this4.props.layerIndex !== layerCursor) return;
      if (e.keyCode === 27) {
        var node = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this4);
        node.click();
      }
      if (e.keyCode === 13) {
        // enter
        e.preventDefault();
        _this4.itemsEmitter.emit('confirm');
      }
      if (e.keyCode === 38 || e.keyCode === 40) {
        // up down
        e.preventDefault();
        var _direction = e.keyCode - 39;
        var max = _this4.getTotalKeyboardItems();
        var newIndex = (_this4.state.hoverCursor + _direction + max) % max;
        _this4.setState({ hoverCursor: newIndex }, function () {
          return _this4.props.onHover(newIndex);
        });
      }
    };

    _this4.getTotalKeyboardItems = function () {
      var max = 0;
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(_this4.props.children, function (e) {
        return max += e && (e.type.isKeyboardNavigable || 0);
      });
      return max;
    };

    _this4.itemsEmitter = __WEBPACK_IMPORTED_MODULE_8_mitt___default.a();

    _this4.setCursorOnHover = function (index) {
      layerCursor = _this4.props.layerIndex;
      _this4.setState({ hoverCursor: index }, function () {
        return _this4.props.onHover(index);
      });
    };

    _this4.state = { hoverCursor: props.autoHover || props.sub ? 0 : -1 };
    return _this4;
  }

  _createClass(ContextMenuComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this5 = this;

      window.addEventListener('keydown', this.keydown);
      this.props.groupEvent.on('layerUpdate', function () {
        return _this5.forceUpdate();
      });
      if (this.props.layers.isFirst()) {
        layerCursor = 0;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onClose && this.props.onClose();
      window.removeEventListener('keydown', this.keydown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.hoverIndex !== this.props.hoverIndex && newProps.hoverIndex !== this.state.hoverCursor) {
        this.setState({ hoverCursor: Math.min(Math.max(newProps.hoverIndex !== undefined ? newProps.hoverIndex : -1, -1), this.getTotalKeyboardItems() + 1) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var i = 0;
      var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (child, j) {
        return child && child.type.isKeyboardNavigable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, {
          hover: _this6.state.hoverCursor === i && _this6.props.layerIndex === layerCursor,
          hoverCursor: _this6.state.hoverCursor,
          index: i++,
          setCursorOnHover: _this6.setCursorOnHover,
          emitter: _this6.itemsEmitter,
          layerIndex: _this6.props.layerIndex
        })) : child;
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ContextListMenu,
        this.props,
        children
      );
    }
  }]);

  return ContextMenuComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class5.defaultProps = { onHover: function onHover() {
    return 0;
  } }, _temp5)) || _class4);


ContextMenu = __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["withLayers"](undefined, 'ContextMenu')(ContextMenuComponent);
ContextMenu.ListItem = ListItem;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styled_components__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

var _templateObject = _taggedTemplateLiteral(['\n  width: 0%;\n  height: 3px;\n  position: fixed;\n  background: #84D359;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  box-shadow: 0 0 6px 0 rgba(0,0,0,0.5);\n  ', ' \n  ', ' \n'], ['\n  width: 0%;\n  height: 3px;\n  position: fixed;\n  background: #84D359;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  box-shadow: 0 0 6px 0 rgba(0,0,0,0.5);\n  ', ' \n  ', ' \n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }






var LoadingBar = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.div(_templateObject, function (props) {
  return props.loading && '\n    width: 70%;\n    transition: 1.5s width linear;\n  ';
}, function (props) {
  return props.closing && '\n    width: 100%;\n    transition: 0.3s ease-in;\n  ';
});

var PageLoader = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"](function (_ref) {
  var appUI = _ref.appUI;
  return { isLoading: appUI.loadings['LAZY_LOAD'] };
}), _dec2 = __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"]('loader'), _dec(_class = _dec2(_class = function (_React$Component) {
  _inherits(PageLoader, _React$Component);

  function PageLoader() {
    _classCallCheck(this, PageLoader);

    return _possibleConstructorReturn(this, (PageLoader.__proto__ || Object.getPrototypeOf(PageLoader)).apply(this, arguments));
  }

  _createClass(PageLoader, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var isLoading = _ref2.isLoading;

      if (this.props.isLoading !== isLoading) {
        if (isLoading) {
          this.props.loader.open();
        } else {
          this.props.loader.closeAfter(500)();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loader = _props.loader,
          className = _props.className;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingBar, { className: className, loading: loader.isOpen, closing: loader.closing });
    }
  }]);

  return PageLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class) || _class);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FillLastLineResizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var FillLastLineResizer = (_temp2 = _class = function (_React$Component) {
  _inherits(FillLastLineResizer, _React$Component);

  function FillLastLineResizer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FillLastLineResizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FillLastLineResizer.__proto__ || Object.getPrototypeOf(FillLastLineResizer)).call.apply(_ref, [this].concat(args))), _this), _this.fontIsLoaded = false, _this.setRef = function (el) {
      _this.el = el;
      if (el && parseInt(_this.el.style.maxWidth, 10) !== parseInt(_this.lastMaxWidth, 10)) {
        _this.resizeEvent();
      }
    }, _this.resizeEvent = function (fontLoaded) {
      var fontAlreadyLoaded = window.getComputedStyle(_this.el).fontWeight === '500' && window.getComputedStyle(_this.el).fontFamily.indexOf('MrRoboto') > 0;
      if (fontAlreadyLoaded) {
        _this.el.style.fontFamily = 'MrRoboto, Roboto, sans-serif';
        _this.fontIsLoaded = true;
      }
      if (_this.fontIsLoaded || _this.props.resizeOnMount || fontLoaded || document.readyState === 'complete') {
        _this.fontIsLoaded = true;
      } else {
        return;
      }
      _this.el.style.removeProperty('max-width');
      if (_this.props.shouldCancelResize === true || typeof _this.props.shouldCancelResize === 'function' && _this.props.shouldCancelResize()) {
        return;
      }

      var _this$el = _this.el,
          offsetWidth = _this$el.offsetWidth,
          offsetHeight = _this$el.offsetHeight;

      if (offsetWidth && offsetHeight) {
        var newMaxWidth = _this.getMaxWidth(_this.el, offsetHeight, offsetWidth, 256, offsetWidth);

        _this.el.style.maxWidth = newMaxWidth + 'px';
        var newOffsetHeight = _this.el.offsetHeight;

        // confere se o maxWidth antigo ainda serve, garantir que não haja influencia de um ou outro pixel

        if (_this.lastMaxWidth) {
          _this.el.style.maxWidth = _this.lastMaxWidth + 'px';
          var lastOffsetHeight = _this.el.offsetHeight;

          if (newOffsetHeight !== lastOffsetHeight || _this.lastMaxWidth >= _this.el.offsetWidth) {
            // if (this.el.tagName.toLowerCase()==='ul') {
            // console.log(newMaxWidth)
            // }
            _this.lastMaxWidth = newMaxWidth;
            _this.el.style.maxWidth = _this.lastMaxWidth + 'px';
          }
        } else {
          _this.lastMaxWidth = newMaxWidth;
        }
      }
    }, _this.getMaxWidth = function (element, prevHeight, prevWidth, window, originalWidth) {
      var newWidth = Math.max(1, prevWidth - window);
      element.style.maxWidth = newWidth + 'px';
      if (element.offsetHeight === prevHeight && prevWidth > 10) {
        return _this.getMaxWidth(element, prevHeight, newWidth, window, originalWidth);
      } else if (window > 1) {
        return _this.getMaxWidth(element, prevHeight, prevWidth, window / 2, originalWidth);
      } else if (prevWidth < 10) {
        return originalWidth > prevWidth ? originalWidth : 10;
      } else {
        return prevWidth + 1;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FillLastLineResizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('stepResize', this.resizeEvent);
      if (document.readyState === 'complete') {
        this.resizeEvent();
      } else {
        window.addEventListener('load', this.resizeEvent);
        if (window.document.fonts) {
          window.document.fonts.ready.catch(function (_) {
            return _;
          }).then(function () {
            window.removeEventListener('load', _this2.resizeEvent);
            _this2.resizeEvent(true);
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('stepResize', this.resizeEvent);
      window.removeEventListener('load', this.resizeEvent);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.resizeEvent();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.Tag,
          linkColor = _props.linkColor,
          resizeOnMount = _props.resizeOnMount,
          shouldCancelResize = _props.shouldCancelResize,
          rest = _objectWithoutProperties(_props, ['Tag', 'linkColor', 'resizeOnMount', 'shouldCancelResize']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ ref: this.setRef }, rest));
    }
  }]);

  return FillLastLineResizer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.defaultProps = {
  Tag: 'div'
}, _temp2);

FillLastLineResizer.ul = function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FillLastLineResizer, _extends({ Tag: 'ul' }, props));
};
FillLastLineResizer.h2 = function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FillLastLineResizer, _extends({ Tag: 'h2' }, props));
};

/***/ })
/******/ ]);
});
//# sourceMappingURL=components.js.map


//////////////////
// WEBPACK FOOTER
// ./~/startlibs/lib/components.js
// module id = 1
// module chunks = 4